import { PendingLiveSession } from "../live/liveHelper";
import i18nPackage from "../../i18n/i18n";
import styles from "./index.module.css";
import { UseEditQuizNavigationReturn } from "../hooks/useEditQuizNavigation";
import { ProctoringDataType } from "../hooks/state/useSettingsState";
import { EditQuizPageProps } from "../editQuiz";
import { VerityInstituteSettings } from "../../types/common";
import { OptionRelatedInstituteSettings, ProctoringOptionProfileV2 } from "@verity/proctoring-option/types";
import StepDescription, { StepWrapper } from "./CommonStepComponents";
import ConfirmationSummaryList from "../confirmation/ConfirmationSummaryList";
import { ThirdPartyBlock } from "../confirmation";

export type ConfirmationPageProps = {
	exemptionCount: number;
	pendingLiveSessions: PendingLiveSession[];
	loading?: boolean;
	handleGoToStep: UseEditQuizNavigationReturn["handleGoToStep"];
	data: ProctoringDataType;
	verityInstituteSettings: VerityInstituteSettings;
	optionRelatedInstituteSettings?: OptionRelatedInstituteSettings;
	activeProfile?: ProctoringOptionProfileV2;
} & Required<
	Pick<
		EditQuizPageProps,
		"enforcedProfilesOnly" | "proctoringOption" | "proctoringAssessmentConfiguration" | "quizType"
	>
> &
	Pick<EditQuizPageProps, "quizName">;

export default function ConfirmationPage({
	exemptionCount,
	pendingLiveSessions,
	loading,
	handleGoToStep,
	quizType,
	data,
	enforcedProfilesOnly,
	proctoringOption,
	verityInstituteSettings,
	optionRelatedInstituteSettings,
	proctoringAssessmentConfiguration,
	activeProfile,
	quizName,
}: ConfirmationPageProps) {
	return (
		<StepWrapper>
			<div className={styles.confirmationPage}>
				<StepDescription loading={loading}>
					{i18nPackage.t("editQuizPage.confirmationBlockTSX.description")}
				</StepDescription>
				{proctoringAssessmentConfiguration.thirdPartyAssessmentOption && (
					<ThirdPartyBlock
						thirdPartyOption={proctoringAssessmentConfiguration.thirdPartyAssessmentOption}
						onEdit={() => handleGoToStep("thirdParty")}
						thirdPartyPlatforms={data.thirdPartyPlatforms}
						quizName={quizName}
						loading={loading}
					/>
				)}
				<ConfirmationSummaryList
					numExempted={exemptionCount}
					pendingLiveSessions={pendingLiveSessions}
					loading={loading}
					handleGoToStep={handleGoToStep}
					quizType={quizType}
					verityInstituteSettings={verityInstituteSettings}
					optionRelatedInstituteSettings={optionRelatedInstituteSettings}
					activeProfile={activeProfile}
					applications={data.applications}
					extensions={data.extensions}
					enforcedProfilesOnly={enforcedProfilesOnly}
					proctoringOption={proctoringOption}
					proctoringAssessmentConfiguration={proctoringAssessmentConfiguration}
				/>
			</div>
		</StepWrapper>
	);
}
